import { ServiceBase } from "@app/shared";
import { WeeklyJobStatisticsResult, HumanaJobStatisticsResult, JobStatisticsByLineOfBusinessResult, ProviderSetCountResult, ProviderSetVersionResult, FullJobDetailsByStatusResponse } from "./jobStatisticsResult";

export default class OperationsService extends ServiceBase {
  public async getHumanaJobStatistics(weekStartDate: string, userId: number, clientId: number): Promise<HumanaJobStatisticsResult[]> {
    return await this.makeGet<HumanaJobStatisticsResult[]>(`/operations/job-statistics?weekStartDate=${weekStartDate}&userId=${userId}&clientId=${clientId}`);
  }

  public async getWeeklyJobStatistics(clientId: number, lineOfBusiness: string, runDate: string): Promise<WeeklyJobStatisticsResult[]> {
    const requestPayload = {
      ClientId: clientId,
      LineOfBusiness: lineOfBusiness,
      RunDate: runDate,
    };

    return await this.makePost<WeeklyJobStatisticsResult[]>("/operations/weekly-job-statistics", requestPayload);
  }

  public async getJobStatisticsByLineOfBusiness(clientId: number, runDate: string, lineOfBusiness: string, jobType: number): Promise<JobStatisticsByLineOfBusinessResult> {
    const requestPayload = {
      ClientId: clientId,
      JobType: jobType,
      LineOfBusiness: lineOfBusiness,
      RunDate: runDate,   
    };

    return await this.makePost<JobStatisticsByLineOfBusinessResult>("/operations/job-statistics-by-line-of-business", requestPayload);
  }

  public async getLinesOfBusiness(clientId: number): Promise<string[]> {
    return await this.makeGet<string[]>("/operations/lines-of-business", {
      clientId
    });
  }

  public async getUnfinishedProjectNames(runDate: string, clientId: number, lineOfBusiness: string): Promise<{ projectName: string }[]> {
    return await this.makeGet<Array<{ projectName: string }>>(`/operations/unfinished-projects?runDate=${runDate}&clientId=${clientId}&lineOfBusiness=${lineOfBusiness}`);
  }

  public async getFullJobDetailsByStatus(runDate: string, clientId: number, jobStatus: string, lineOfBusiness: string, jobType: number): Promise<FullJobDetailsByStatusResponse[]> {
    return await this.makeGet<FullJobDetailsByStatusResponse[]>(`/operations/full-job-details?runDate=${runDate}&clientId=${clientId}&jobStatus=${jobStatus}&lineOfBusiness=${lineOfBusiness}&jobType=${jobType}`);
  }

  public async getProviderSetCounts(clientId: number, dateCreated: string): Promise<ProviderSetCountResult[]> {
    return await this.makeGet<ProviderSetCountResult[]>(`/operations/provider-set-counts?dateCreated=${dateCreated}&clientId=${clientId}`);
  }

  public async getProviderSetVersions(clientId: number, dateCreated: string, isActive: boolean): Promise<ProviderSetVersionResult[]> {
    return await this.makeGet<ProviderSetVersionResult[]>(`/operations/provider-set-versions?dateCreated=${dateCreated}&clientId=${clientId}&isActive=${isActive}`);
  }

  public async getAllClients(): Promise<{ clientId: number, name: string }[]> {
    return await this.makeGet<{ clientId: number, name: string }[]>("/clients");
  }

  public async getUsersByClient(clientId: number): Promise<{ userId: number, userName: string }[]> {
    return await this.makeGet<{ userId: number, userName: string }[]>(`/users/client/${clientId}`);
  }
}